import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { LogIn, Loader2, UserPlus } from "lucide-react";

const AfiliadoLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      toast({ title: "Preencha todos os campos", variant: "destructive" });
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      toast({ title: "Erro ao fazer login", description: error.message, variant: "destructive" });
      setLoading(false);
      return;
    }

    // Check if user is an affiliate
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      toast({ title: "Erro ao verificar conta", variant: "destructive" });
      setLoading(false);
      return;
    }

    console.log("Affiliate login - user.id:", user.id);
    const { data: affiliate, error: affiliateError } = await supabase
      .from("affiliates")
      .select("id, status")
      .eq("user_id", user.id)
      .maybeSingle();

    console.log("Affiliate query result:", { affiliate, affiliateError });

    if (affiliateError || !affiliate) {
      toast({ title: "Conta de afiliado não encontrada", description: affiliateError?.message || "Este email não está cadastrado como afiliado.", variant: "destructive" });
      await supabase.auth.signOut();
      setLoading(false);
      return;
    }

    if (affiliate.status === "pending") {
      toast({ title: "Conta em análise", description: "Sua solicitação ainda está sendo avaliada. Aguarde a aprovação.", variant: "destructive" });
      await supabase.auth.signOut();
      setLoading(false);
      return;
    }

    setLoading(false);
    navigate("/afiliado");
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-4">
            <LogIn className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-2xl font-bold font-display">Portal do Afiliado</h1>
          <p className="text-sm text-muted-foreground mt-1">Acesse sua conta e acompanhe seus resultados</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4 rounded-2xl border border-border bg-card p-6">
          <div className="space-y-1.5">
            <Label className="text-sm">Email</Label>
            <Input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com"
              className="h-11"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm">Senha</Label>
            <Input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              className="h-11"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-gradient-primary text-primary-foreground">
            {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <LogIn className="h-4 w-4 mr-2" />}
            Entrar
          </Button>
        </form>

        <div className="text-center mt-4">
          <p className="text-sm text-muted-foreground">
            Ainda não é afiliado?{" "}
            <Link to="/afiliado/cadastro" className="text-primary font-medium hover:underline">
              Cadastre-se aqui
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AfiliadoLogin;
